import { call, put, takeLatest, cancelled } from "redux-saga/effects"
import axios from "axios"
import {
  GET_MEDITIONS_WATCHER,
  MEDITIONS_ACTIONS_WATCHER,
  OFFICIALIZE_MEDITIONS_WATCHER,
  GET_SURVEY_TYPES_WATCHER,
  GET_MEASURE_WATCHER,
} from "./constants"

import {
  getSurveyTypesSuccess,
  getSurveyTypesFailed,
  getMeditionsAvailableActionsFailed,
  getMeditionsAvailableActionsSuccess,
  getMeditionsSuccess,
  getMeditionsFailed,
  officializeFailed,
  officializeSuccess,
  getMeasureSuccess,
  getMeasureFailed,
} from "./actions"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../../utils/storage"
import { validate } from "../../../utils/functions"
import { GET_MEASURES_WATCHER } from "../../../containers/Collaborators/constants"

function getSurveyTypesApi() {
  const url = `companies/surveytypes?id_company=${LOCAL_COMPANY_ID()}`
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}


function getMeasureApi(id_measure) {
  const url = `measure/${id_measure}`
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}


function getMeditionsApi(params) {
  const url = `v2/companies/${LOCAL_COMPANY_ID()}/reports/measures`
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params,
  })
}

function getMeditionAvailableActionsApi(params) {
  const url = `reports/measure/${params.payload.measure_id}/available-actions`
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: {
      id_division: params.payload.id_division,
    },
  })
}

export function* getMeasureSaga(params) {
  try {
    const restApi = yield call(getMeasureApi, params.payload.id_measure)
    yield put(getMeasureSuccess(restApi.data))
  } catch (e) {
    console.log(e)
    yield put(getMeasureFailed())
  }
}

export function* getMeditionsSaga(params = {}) {
  try {
    let payload = {
      id_survey_type: params.payload.id_survey_type
    }
    if (params.payload.preSelectedDivision != null) {
      payload.pre_selected_division = params.payload.preSelectedDivision
    }
    const meditionsApi = yield call(getMeditionsApi, {
      "all-data": 0,
      ...payload
    })
    const result = {
      meditions: meditionsApi.data.data.measure.filter(
        (x) => x.id_measure_status >= 3
      ),
      ambassador_count: meditionsApi.data.data.ambassador_count,
      allMeditions: meditionsApi.data.data.measure,
    }

    result.isEmptyMeditions = result.meditions.length === 0

    if (
      !validate.exist(params.payload.idMeasure) &&
      result.meditions.length > 0
    ) {
      const searchLocation = getUrlParams(
        params.payload.history.location.search
      )
      if (
        validate.exist(searchLocation) &&
        validate.exist(searchLocation.id_division)
      ) {
        params.payload.history.push(
          `/reports/measure/${result.meditions[0].id_measure}?id_division=${searchLocation.id_division}`
        )
      } else {
        params.payload.history.push(
          `/reports/measure/${result.meditions[0].id_measure}`
        )
      }
    }
    yield put(getMeditionsSuccess(result))
  } catch (e) {
    // Primero el fallo: sin esto loadingMeditions queda en true y el reporte nunca se renderiza
    yield put(getMeditionsFailed())
    // returnMessage lanza TypeError cuando la respuesta no trae data.data (500, error de red)
    try {
      returnMessage(e, true)
    } catch (messageError) {
      console.error(messageError)
    }
  }
}

export function* officializeSaga(action) {
  try {
    const meditionsApi = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `measure/${action.payload}/officialize`,
    })

    message.success("Se ha oficializado la medición correctamente.", 5)
    yield put(officializeSuccess({}))
  } catch (e) {
    message.error("Hubo un error al oficializar la medición.", 5)
    yield put(officializeFailed())
  }
}

export function* getMeditionAvailableActionsSaga(params = {}) {
  try {
    const restApi = yield call(getMeditionAvailableActionsApi, params)

    yield put(getMeditionsAvailableActionsSuccess(restApi.data.data))
  } catch (e) {
    // returnMessage(e, true)
    yield put(getMeditionsAvailableActionsFailed())
  }
}

export function* getSurveyTypesSaga() {
  try {
    const restApi = yield call(getSurveyTypesApi)
    yield put(getSurveyTypesSuccess(restApi.data))
  } catch (e) {
    returnMessage(e, true)
    yield put(getSurveyTypesFailed())
  }
}

// Individual exports for testing
export default function* reportHeaderV2Saga() {
  yield takeLatest(GET_MEDITIONS_WATCHER, getMeditionsSaga)
  yield takeLatest(OFFICIALIZE_MEDITIONS_WATCHER, officializeSaga)
  yield takeLatest(MEDITIONS_ACTIONS_WATCHER, getMeditionAvailableActionsSaga)
  yield takeLatest(GET_SURVEY_TYPES_WATCHER, getSurveyTypesSaga)
  yield takeLatest(GET_MEASURE_WATCHER, getMeasureSaga)
  // See example in containers/HomePage/saga.js
}
